// prices.js
export const prices = {
  'recurring_1': {'CAD': {'unit_amount': 1999},'GBP': {'unit_amount': 1699},'INR': {'unit_amount': 79900},'USD': {'unit_amount': 1999}},
  'recurring_3': {'CAD': {'unit_amount': 4999},'GBP': {'unit_amount': 4249},'INR': {'unit_amount': 199900},'USD': {'unit_amount': 4999}},
  'recurring_12': {'CAD': {'unit_amount': 9999},'GBP': {'unit_amount': 8499},'INR': {'unit_amount': 399900},'USD': {'unit_amount': 9999}},
'one_time_1': {'CAD': {'unit_amount': 2299},'GBP': {'unit_amount': 1999},'INR': {'unit_amount': 89900},'USD': {'unit_amount': 2299}},
'one_time_3': {'CAD': {'unit_amount': 5799},'GBP': {'unit_amount': 4999},'INR': {'unit_amount': 229900},'USD': {'unit_amount': 5799}},
'one_time_12': {'CAD': {'unit_amount': 11499},'GBP': {'unit_amount': 9799},'INR': {'unit_amount': 449900},'USD': {'unit_amount': 11499}},
};
